require('../../modules/es6.reflect.own-keys');
module.exports = require('../../modules/_core').Reflect.ownKeys;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/own-keys.js
// module id = 860
// module chunks = 36